import {
	EASTER_EGGS_LOADING,
	EASTER_EGGS_SUCCESS,
	EASTER_EGGS_FAILURE,
	USER_EASTER_EGGS_LOADING,
	USER_EASTER_EGGS_LOADING_SUCCESS,
	USER_EASTER_EGGS_LOADING_FAILURE,
	POST_EASTER_EGG_FOUND_SUCCESS,
	POST_EASTER_EGG_FOUND_FAILURE,
	AM_I_MASTER_EGG_HUNTER_SUCCESS,
	AM_I_MASTER_EGG_HUNTER_FAILURE,
	MASTER_EGG_HUNTERS_LOADING,
	GET_MASTER_EGG_HUNTERS_SUCCESS,
	GET_MASTER_EGG_HUNTERS_FAILURE,
	CLEAR_AM_I_MASTER_EGG_HUNTER,
} from 'redux/reduxConstants';
import { EasterEgg } from 'redux/models/easterEgg';
import { UserEgg } from 'redux/models/userEgg';
import { EggHunter } from 'redux/models/eggHunter';

export function easterEggsLoading() {
	return { type: EASTER_EGGS_LOADING };
}

export function easterEggsSuccess(easterEgg: EasterEgg) {
	return { type: EASTER_EGGS_SUCCESS, easterEgg };
}

export function easterEggFailure(error: string) {
	return { type: EASTER_EGGS_FAILURE, error };
}

export function userEasterEggsLoading() {
	return { type: USER_EASTER_EGGS_LOADING };
}

export function userEasterEggsLoadingSuccess(userEgg: UserEgg) {
	return { type: USER_EASTER_EGGS_LOADING_SUCCESS, userEgg };
}

export function userEasterEggsLoadingFailure(error: string) {
	return { type: USER_EASTER_EGGS_LOADING_FAILURE, error };
}

export function postEasterEggFoundSuccess(userEgg: UserEgg) {
	return { type: POST_EASTER_EGG_FOUND_SUCCESS, userEgg };
}

export function postEasterEggFoundFailure(error: string) {
	return { type: POST_EASTER_EGG_FOUND_FAILURE, error };
}

export function getAmIMasterEggHunterSuccess(isMasterEggHunter: boolean) {
	return { type: AM_I_MASTER_EGG_HUNTER_SUCCESS, isMasterEggHunter };
}

export function getAmIMasterEggHunterFailure(error: string) {
	return { type: AM_I_MASTER_EGG_HUNTER_FAILURE, error };
}

export function masterEggHuntersLoading() {
	return { type: MASTER_EGG_HUNTERS_LOADING };
}

export function getMasterEggHuntersSuccess(masterEggHunters: EggHunter[]) {
	return { type: GET_MASTER_EGG_HUNTERS_SUCCESS, masterEggHunters };
}

export function getMasterEggHuntersFailure(error: string) {
	return { type: GET_MASTER_EGG_HUNTERS_FAILURE, error };
}

export function clearAmIMasterEggHunter() {
	return { type: CLEAR_AM_I_MASTER_EGG_HUNTER };
}
